import React, { useState, useEffect, useRef } from 'react';
import BasicCard from './basics/cards/BasicCard'
import AlertMessage from './AlertMessage';
import { CommonAPIService } from "../services/apis/CommonAPIService";
import { ErrorService } from '../services/ErrorService';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import $ from 'jquery'; 

function ReportTable({ filterArray, pageConfig, downloadOptions, setUpdatingFilter }) {        
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { apiName, controllerName, pageSettings } = pageConfig    
    const [alertObject, setAlertObject] = useState({ variant: '', alertMessage: '' });


    const tableRef = useRef(null);
    const dataTableRef = useRef(null);

    const { hasDownload, setSelectedDownloadItems, selectedDownloadItems } = downloadOptions ? downloadOptions : { hasDownload: false, setSelectedDownloadItems: () => { }, selectedDownloadItems: [] };
    const { tableColumns, tableColumnIds } = { tableColumns: ['Download', 'Name', 'Scenario type', 'Percentage type', 'memo'], tableColumnIds: ['scenarioID', 'scenarioName', 'scenarioType', 'percentageType', 'memo'] };

    useEffect(() => {
        if (!Array.isArray(filterArray)) return 


        // Destroy existing DataTable before reinitializing
        if (dataTableRef.current) {
            dataTableRef.current.destroy();
            dataTableRef.current = null;
        }            

        setUpdatingFilter(true)
        const filterArrayString = encodeURIComponent(JSON.stringify(filterArray));            
        // fetch data from API          

        CommonAPIService.callApiUsingUrl(`${apiName}${controllerName}/Data?filterArray=${filterArrayString}`)
            .then(response => {
                setIsLoading(false);
                if (response.error) {
                    const errorMessage = ErrorService.getErrorMessage(response.error.status)
                    setAlertObject({ variant: 'danger', alertMessage: errorMessage })
                }
                else {                  
                    setUpdatingFilter(false)
                    setData(response);
                    setAlertObject({ variant: '', alertMessage: '' })
                }
            })        

    }, [apiName, controllerName, filterArray]);


    function handleDownloadSelect(event, item) {
        
        const itemIndex = selectedDownloadItems.indexOf(item)
        if (event.target.checked) {
            if (itemIndex < 0) {
                setSelectedDownloadItems([...selectedDownloadItems, item])
            }
        } else {
            const newSelection = itemIndex === 0 && selectedDownloadItems.length < 1 ? [] : selectedDownloadItems.toSpliced(itemIndex, 1)
            setSelectedDownloadItems(newSelection)
        }
    }

    function renderRow(row) {
        if (typeof row === 'object')
            return "";
        else if (typeof row === 'string')
            return row.replace("\u0000", "")
        else
            return row;
    }


    return (
        <BasicCard cardConfig={{ cardTitle: pageSettings ? pageSettings.name + ' selection' : '...', cardHeadingElement: 'h5' }}>
            {isLoading ? <p>Loading data ...</p> : ""}
            {alertObject.alertMessage ? <AlertMessage alertObject={alertObject} setAlertObject={setAlertObject} /> : ""}               
                <div className='listing-table-wrapper'>                 
                    <table className='react-data-table' ref={tableRef}>
                        <thead>
                            <tr>
                                {tableColumns.map((tableCol, index) => {
                                    if (tableCol === 'scenarioID') return (<th key={index}>Download</th>);
                                    return (<th key={index}>{tableCol}</th>)
                                })}                              
                            </tr>
                    </thead>
                    {!isLoading && data?.length > 0 && tableColumns.length > 0 && (
                        <tbody>
                            {
                                data.map((tableRow, index) => {
                                    return (
                                        <tr className={'react-data-table-effect'} key={index}>
                                            <td onChange={e => handleDownloadSelect(e, tableRow)}><div className='download-input'><input type='checkbox' /></div></td>
                                            {tableColumnIds.map((tableCol, index) => {
                                                if (tableCol === 'scenarioID') return "";
                                                return (
                                                    <td key={1000 + index}>
                                                        <div className='data-table-input-cell'>
                                                            <p className='data-table-text'>{renderRow(tableRow[tableCol])}
                                                            </p>
                                                        </div>
                                                    </td>
                                                )
                                            })}

                                        </tr>
                                    )
                                })}
                        </tbody>)
                    }</table>
                </div>                
        </BasicCard>
    );
}

export default ReportTable;
